import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
} from "@mui/material";

import { useTheme } from "@mui/material/styles";

const HUDForm = ({ HUDSummary, payoutDict, singleItemAnalysisData }) => {
  const theme = useTheme();

  // Format currency
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
    }).format(amount);
  };

  return (
    <TableContainer
      component={Paper}
      sx={{
        borderRadius: theme.spacing(0.25),
        mb: 4,
        boxShadow: "none",
        border: "none",
      }}
    >
      <Table
        size="small"
        sx={{
          "& .MuiTableCell-root": {
            borderTop: "none",
            borderLeft: "none",
            borderRight: "none",
            borderBottom: "1px solid rgba(224, 224, 224, 1)",
            padding: "8px 16px",
          },
          borderCollapse: "collapse",
          "& .MuiTableRow-root:last-child .MuiTableCell-root": {
            borderBottom: "none",
          },
        }}
      >
        <TableHead>
          <TableRow sx={{ backgroundColor: "#e0e0e0" }}>
            <TableCell
              colSpan={7}
              align="center"
              sx={{
                fontWeight: "bold",
                borderBottom: "1px solid rgba(224, 224, 224, 1)",
              }}
            >
              <Typography variant="subtitle1" fontWeight="bold">
                SETTLEMENT STATEMENT DISCLOSURE (HUD-1 or ALTA)
              </Typography>
            </TableCell>
          </TableRow>
          <TableRow sx={{ backgroundColor: "#e0e0e0" }}>
            <TableCell
              sx={{
                fontWeight: "bold",
                width: "10%",
                borderBottom: "1px solid rgba(224, 224, 224, 1)",
              }}
            >
              1000
            </TableCell>
            <TableCell
              colSpan={6}
              sx={{
                fontWeight: "bold",
                borderBottom: "1px solid rgba(224, 224, 224, 1)",
              }}
            >
              Reserves Deposited with Lender
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>1001</TableCell>
            <TableCell>Initial deposit for your escrow account</TableCell>
            <TableCell colSpan={3} align="right"></TableCell>
            <TableCell></TableCell>
            <TableCell align="right" sx={{ fontWeight: "bold" }}>
              {formatCurrency(HUDSummary?.initialDeposit || 0)}
            </TableCell>
          </TableRow>

          {Object.keys(singleItemAnalysisData).map((payoutKey, index) => {
            const t = HUDSummary[payoutKey];

            return (
              <TableRow key={payoutKey}>
                <TableCell>{1002 + index}</TableCell>
                <TableCell>{payoutDict[payoutKey]}</TableCell>
                <TableCell align="center" sx={{ fontWeight: "bold" }}>
                  {t.months}
                </TableCell>
                <TableCell align="right">months @</TableCell>
                <TableCell align="right" sx={{ fontWeight: "bold" }}>
                  {formatCurrency(t.monthlyAmount)}
                </TableCell>
                <TableCell align="right">per month</TableCell>
                <TableCell align="right" sx={{ fontWeight: "bold" }}>
                  {formatCurrency(t.totalAmount)}
                </TableCell>
              </TableRow>
            );
          })}

          <TableRow>
            <TableCell>
              {1002 + Object.keys(singleItemAnalysisData).length < 1007
                ? 1007
                : 1002 + Object.keys(singleItemAnalysisData).length}
            </TableCell>
            <TableCell>Aggregate Adjustment</TableCell>
            <TableCell colSpan={4}></TableCell>
            <TableCell align="right" sx={{ fontWeight: "bold" }}>
              {formatCurrency(HUDSummary["aggregateAdj"].amount)}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default HUDForm;
